import type { Tab } from "types/tabs.types"

export const getAccountSettingsTabsConfig = (): Tab[] => [
  {
    labelKey: "account_settings.GENERAL",
    value: 0,
    to: { pathname: "" },
  },
  {
    labelKey: "account_settings.SECURITY",
    value: 1,
    to: { pathname: "security" },
  },
]
